module.exports = __webpack_public_path__ + "img/carshina22_06.55cda946.jpg";